import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { createProviderToken } from '@recruitee/common';

import { PdfViewerConfig, PdfViewerErrorContexts } from './pdf-viewer.types';

export const PDF_VIEWER_CONFIG_TOKEN = new InjectionToken<PdfViewerConfig>(
  'PDF_VIEWER_CONFIG_TOKEN',
);

export const { provide: providePdfViewerErrorContexts, inject: injectPdfViewerErrorContexts } =
  createProviderToken<Observable<PdfViewerErrorContexts>>('Pdf viewer error contexts')();
